import ParsedDayScheduleCalendar from '@/components/Common/ParsedDayScheduleCalendar';
import { hDeepCopy } from '@/utils/helpers';

export default {
  name: 'ProjectsListItem',

  components: {
    ParsedDayScheduleCalendar,
  },

  props: {
    project: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      projectCopy: null,
    };
  },

  created() {
    this.projectCopy = hDeepCopy(this.project);
  },

  methods: {
    handleGoToProfile() {
      this.$router.push({ name: 'PlatformProjectDetails', params: { projectUuid: this.project.uuid } });
    },
  },
};
